var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#134A81",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 1.1,
    d: "M67.667 23.222V1H14.333v22.222L1 32.112V81h80V32.111l-13.333-8.889zm5.32 8.89l-5.32 3.546v-7.094l5.32 3.547zm-9.765 6.51L41 53.436 18.778 38.621V5.444h44.444v33.178zM14.333 28.564v7.094l-5.32-3.547 5.32-3.547zm62.223 47.992H5.444V35.074L41 58.778l35.556-23.704v41.482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.444 12.111h31.111V21H25.444z"
  }))));
}
export default SvgConfirmation;